import { CreateOrUpdateTaskIntegrationDto } from './create-or-update-task-integration-dto';
import { TaskBaseDto } from './task-base-dto';

export class CreateOrUpdateTaskDto extends TaskBaseDto {
  validationRuleId: number;
  informationFieldIds: number[];
  priorTaskIds: number[];
  nextTaskIds: number[];
  integrations: CreateOrUpdateTaskIntegrationDto[];
}
